import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import _ from "lodash";
import AuthPage from "../containers/AuthPage";
import TicketConfirmationPage from "../containers/TicketConfirmationPage";
import TicketPage from "../containers/TicketPage";
import TicketErrorPage from "./TicketErrorPage";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useHistory } from "react-router-dom";

class TicketBase extends Component {
    constructor(props) {
        super(props);
        this.state = {
            urlParameters: {
                ticketId: null
            },
            isSubmitted: false
        };
    }

    componentWillMount() {
        this.getViewQueryParameters();

        if (
            window.localStorage.getItem("-rma-jwt") !== null &&
            window.localStorage.getItem("-rma-jwt") !== undefined &&
            window.localStorage.getItem("-rma-jwt") !== ""
        ) {
            this.props.setAuthToken({
                id: null,
                email_address: null,
                result: window.localStorage.getItem("-rma-jwt")
            });
        }
    }

    getViewQueryParameters() {
        let search = this.props.location.search;

        if (search) {
            let params = search.substring(1, search.length).split("&");

            for (let index = 0; index < params.length; index++) {
                let q = params[index].split("=");

                if (q[0].toUpperCase() === "ID" && q[1] !== "") {
                    this.setState({
                        urlParameters: {
                            ticketId: q[1]
                        }
                    });
                }
            }
        }
    }

    componentDidMount() {
        this.props.resetTicket();

        if (!this.state.urlParameters.ticketId) {
            this.props.history.push("/tickets/search");
        }

        if (this.state.urlParameters.ticketId) {
            this.props.verifyTicket(this.state.urlParameters.ticketId);
        }

        if (
            !this.props.ticket &&
            this.props.ticketLoading === false &&
            this.state.urlParameters &&
            this.state.urlParameters.ticketId &&
            this.isAuthenticated() &&
            !this.props.ticketFetchingError &&
            !this.props.authTokenFetchingError &&
            this.props.authToken &&
            this.props.authToken.result
        ) {
            this.props.getTicket(this.state.urlParameters.ticketId);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (
            this.props.authTokenLoading === false &&
            prevProps.authTokenLoading === true &&
            !this.props.authTokenFetchingError &&
            this.props.authToken &&
            this.props.authToken.result
        ) {
            window.localStorage.setItem("-rma-jwt", this.props.authToken.result);
            this.props.resetTicket();
        }

        if (
            !this.props.ticket &&
            this.props.ticketLoading === false &&
            this.state.urlParameters &&
            this.state.urlParameters.ticketId &&
            this.isAuthenticated() &&
            !this.props.ticketFetchingError &&
            !this.props.authTokenFetchingError &&
            this.props.authToken &&
            this.props.ticketVerifying == false &&
            !this.props.ticketVerifyingError
        ) {
            this.props.getTicket(this.state.urlParameters.ticketId);
        }

        if (this.props.ticketVerifying === false && prevProps.ticketVerifying === true) {
            if (this.props.ticketVerifyingError) {
                this.props.history.push("/tickets/search");
            } else if (this.props.ticketVerifyData) {
                this.props.setLanguage(this.props.ticketVerifyData.language);
            }
        }

        // if (this.props.authTokenVerifying === false && prevProps.authTokenVerifying === true && this.props.authTokenVerifyingError) {
        //     this.props.history.push("/tickets");
        // }
    }

    isAuthenticated() {
        return (
            this.props.authToken &&
            this.props.authToken.result &&
            window.localStorage.getItem("-rma-jwt") !== null &&
            window.localStorage.getItem("-rma-jwt") !== undefined &&
            window.localStorage.getItem("-rma-jwt") !== ""
        );
    }

    handleSubmit() {
        this.setState({
            isSubmitted: true
        });
    }

    isTicketUnderAddressVerification() {
        return this.props.ticket && this.props.ticket.requests && this.props.ticket.requests.some(r => r.addressConfirmation === true);
    }

    render() {
        if (this.props.ticketLoading || this.props.languageListLoading || this.props.ticketVerifying) {
            return (
                <div className="relative flex layout vertical">
                    <div className="loading-box fit layout vertical center-center">
                        <CircularProgress size={40} thickness={6} color="primary" />
                    </div>
                </div>
            );
        }

        if (
            !this.isAuthenticated() ||
            (this.isAuthenticated() &&
                ((this.props.ticketFetchingError && this.props.ticketFetchingError === "Authentication Error") ||
                    (this.props.ticketUpdatingError && this.props.ticketUpdatingError === "Authentication Error") ||
                    (this.props.returnLabelLoadingError && this.props.returnLabelLoadingError === "Authentication Error")))
        ) {
            return <AuthPage ticketId={this.state.urlParameters.ticketId} />;
        }

        if (this.isAuthenticated() && this.props.ticket && !this.isTicketUnderAddressVerification()) {
            return <TicketPage ticketId={this.state.urlParameters.ticketId} />;
        }

        if (
            this.isAuthenticated() &&
            !this.props.ticketFetchingError &&
            !this.props.ticketLoading &&
            this.props.ticket &&
            this.isTicketUnderAddressVerification()
        ) {
            return <TicketConfirmationPage handleSubmit={this.handleSubmit.bind(this)} ticketId={this.state.urlParameters.ticketId} />;
        }

        return <TicketErrorPage />;
    }
}

export default withRouter(TicketBase);
